import { DxButtonModule, DxDataGridModule, DxScrollViewModule } from 'devextreme-angular';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectionOptionsRendererComponent } from './selection-options-renderer.component';
import { SelectionSetRendererModule } from '../selection-set-renderer/selection-set-renderer.module';



@NgModule({
  declarations: [
    SelectionOptionsRendererComponent
  ],
	exports: [
		SelectionOptionsRendererComponent
	],
  imports: [
    CommonModule,

		SelectionSetRendererModule,

		DxDataGridModule,
		DxButtonModule,
		DxScrollViewModule,
  ]
})
export class SelectionOptionsRendererModule { }
